<template>
  <div class="sc-year-month-picker">
    <el-date-picker
      ref="elDatePicker"
      prefix-icon="el-icon-time"
      :clearable="false"
      :editable="false"
      v-model="value"
      type="month"
      format="yyyy/MM"
      @change="change"
      :picker-options="pickerOptions"
    ></el-date-picker>
    <img src="@/assets/dashboard/menu_arrow@2x.png" @click="open" />
  </div>
</template>

<script>
export default {
  name: "ScYearMonthPicker",
  props: {
    date: {
      type: Date
    }
  },
  data() {
    const date = this.date;
    return {
      value: date,
      pickerOptions: {
        disabledDate: this.disabledDate,
        shortcuts: [
          {
            text: "本月",
            onClick(picker) {
              picker.$emit("pick", new Date());
            }
          }
        ]
      }
    };
  },
  methods: {
    open() {
      this.$refs["elDatePicker"].focus();
    },
    change(e) {
      this.$emit("change", e);
    },
    disabledDate(e) {
      return e.getTime() > this.date.getTime();
    }
  }
};
</script>

<style lang="scss">
.sc-year-month-picker {
  cursor: pointer;

  .el-date-editor.el-input {
    width: 90px;
  }

  .el-input--prefix .el-input__icon {
    font-size: 18px;
  }

  .el-input--prefix .el-input__inner {
    padding-right: 0;
    padding-left: 35px;
    color: #848791;
  }

  input[type="text"].el-input__inner {
    border: none;
  }

  img {
    width: 7px;
    height: 4px;

    vertical-align: middle;
  }

  .text {
    font-size: 14px;
    font-weight: 500;
    color: rgba(132, 135, 145, 1);
    line-height: 20px;
    vertical-align: top;
  }
}
</style>